import React from "react";

import { _RichNavigation__ProductLink as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import { Flair } from "../../../common/Flair";

import styles from "./index.module.scss";

interface Props {
    value: Value;
    attrs?: IntrinsicElementProps<HTMLElement>;
}

export const RichNavigationProductLink = (
    props: Props,
): React.JSX.Element | null => {
    const isActive =
        !props.value.promo_period || props.value.promo_period.is_promo_active;
    if (!isActive) {
        return null;
    }
    return (
        <a href={props.value.destination?.url}>
            {props.value.flair && <Flair flair={props.value.flair} />}
            {props.value.callout && (
                <RichTextBlock
                    className={styles.callout}
                    value={props.value.callout}
                />
            )}
            {props.value.subtitle && (
                <RichTextBlock
                    className={styles.subtitle}
                    value={props.value.subtitle}
                />
            )}
            {props.value.text && (
                <RichTextBlock
                    className={styles.title}
                    value={props.value.text}
                />
            )}
            {props.value.image && (
                <ImageChooserBlock
                    attrs={{ className: styles.img }}
                    value={props.value.image}
                />
            )}
        </a>
    );
};
